<template>
  <core-main-table
    :headers="headers"
    :items="parts"
    rights-group="rfq"
    show-expand
    class="py-0 my-0"
  >
    <template v-slot:item.data-table-expand="{}">
      <span />
    </template>

    <template v-slot:item.partNo="{item}">
      <v-list-item-title>
        {{ item.material }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ item.filename }}
      </v-list-item-subtitle>
    </template>

    <template v-slot:item.material="{item}">
      <v-select
        v-model="item.material"
        :items="materials"
        outlined
        class="mt-3"
        style="height: 50px;"
        dense
      />
    </template>

    <template v-slot:item.finish="{item}">
      <v-select
        v-model="item.finish"
        :items="finishes"
        outlined
        class="mt-3"
        style="height: 50px;"
        dense
      />
    </template>

    <template v-slot:item.thickness="{item}">
      <v-text-field
        v-model="item.thickness"
        outlined
        class="mt-3"
        style="height: 50px;"
        dense
      />
    </template>

    <template v-slot:item.serial="{item}">
      <v-text-field
        v-model="item.serial"
        outlined
        class="mt-3"
        style="height: 50px;"
        dense
      />
    </template>
  </core-main-table>
</template>

<script>
export default {
  props: [
    'parts'
  ],
  data: () => ({
    materials: [
      'Stainless', 'Steel', 'Aluminium', 'Spring Steel'
    ],

    finishes: [
      'None', 'Clear Zinc', 'Protective Oil', 'Ecoating',
    ],
  }),

  computed: {
    headers() {
      return [
        {
          text: '',
          value: 'data-table-expand',
          visibility: false
        },
        {
          text: 'Part Number',
          value: 'partNo',
        },
        {
          text: 'Material',
          value: 'material',
        },
        {
          text: 'Finish',
          value: 'finish',
        },
        {
          text: 'Thickness/L',
          value: 'thickness',
        },
        {
          text: 'Series/L',
          value: 'serial',
        },
      ];
    }
  },
};
</script>
